import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import { selectors as caseSelectors } from '../../infrastructure/cases';
import { selectors as customerSelector } from '../../infrastructure/customers';
import BusinessDetailsAllPage from './components/BusinessDetailsAllPage';
import {
  dataCaptureSelectors,
  saveBusinessDetailsAllForm,
  saveContactChanges,
  saveTaxFinanceChanges,
  saveBusinessTypeChanges,
  saveBusinessFinanceChanges,
  saveAboutBusinessChanges,
  updateAccordionForm,
  redirectToBusinessAccount,
  onAddressSelection,
  saveAboutYourFormValues,
  onAddressEditClick,
  submitEvidence,
  onCancelEditClick
} from '../../store/dataCapture';
import {
  NAVIGATION_BACK,
  TRADING_ADDRESS_TYPE,
  MAILING_ADDRESS_TYPE,
  REGISTER_ADDRESS_TYPE
} from '../../utils/constants';

class BusinessTypeQuestion extends Component {
  constructor(props) {
    super(props);
    this.businessBack = this.businessBack.bind(this);
  }

  businessBack() {
    this.props.redirectToBusinessAccount(NAVIGATION_BACK);
  }

  render() {
    const {
      bankId,
      brandId,
      saveBusinessDetailsAllForm,
      getBusinessData,
      saveContactChanges,
      saveTaxFinanceChanges,
      saveBusinessTypeChanges,
      saveBusinessFinanceChanges,
      isSoleBusinessType,
      saveAboutBusinessChanges,
      getCustomerData,
      updateAccordionForm,
      businessId,
      address,
      redirectToBusinessAccount,
      registerAddress,
      tradingAddress,
      mailingAddress,
      saveAboutYourFormValues,
      editButtonClicks,
      onAddressEditClick,
      caseId,
      submitEvidence,
      caseType,
      linkCode,
      onCancelEditClick,
      customerData
    } = this.props;

    return (
      <BusinessDetailsAllPage
        brandId={brandId}
        bankId={bankId}
        saveBusinessDetailsAllForm={saveBusinessDetailsAllForm}
        backClick={this.businessBack}
        getBusinessData={getBusinessData}
        isSoleBusinessType={isSoleBusinessType}
        saveContactChanges={saveContactChanges}
        saveTaxFinanceChanges={saveTaxFinanceChanges}
        saveBusinessTypeChanges={saveBusinessTypeChanges}
        saveBusinessFinanceChanges={saveBusinessFinanceChanges}
        saveAboutBusinessChanges={saveAboutBusinessChanges}
        getCustomerData={getCustomerData}
        updateAccordionForm={updateAccordionForm}
        businessId={businessId}
        address={address}
        redirectToBusinessAccount={redirectToBusinessAccount}
        registerAddressValue={registerAddress}
        tradingAddressValue={tradingAddress}
        mailingAddressValue={mailingAddress}
        saveAboutYourFormValues={saveAboutYourFormValues}
        editButtonClicks={editButtonClicks}
        onAddressEditClick={onAddressEditClick}
        onAddressSelection={onAddressSelection}
        caseId={caseId}
        submitEvidence={submitEvidence}
        linkCode={linkCode}
        caseType={caseType}
        customerData={customerData}
        onCancelEditClick={onCancelEditClick}
      />
    );
  }
}

BusinessTypeQuestion.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveBusinessDetailsAllForm: PropTypes.func.isRequired
};

const actionCreators = {
  saveBusinessDetailsAllForm,
  saveContactChanges,
  saveTaxFinanceChanges,
  saveBusinessTypeChanges,
  saveBusinessFinanceChanges,
  saveAboutBusinessChanges,
  updateAccordionForm,
  redirectToBusinessAccount,
  onAddressSelection,
  saveAboutYourFormValues,
  onAddressEditClick,
  submitEvidence,
  onCancelEditClick
};

const mapStateToProps = (state) => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  getBusinessData: dataCaptureSelectors.getBusinessData(state),
  businessId: caseSelectors.business_uuid(state) || dataCaptureSelectors.businessId(state),
  isSoleBusinessType: dataCaptureSelectors.isSoleBusinessType(state),
  getCustomerData: dataCaptureSelectors.getCustomerData(state),
  address: caseSelectors.getAddress(state),
  registerAddress: dataCaptureSelectors.getRegisterAddress(state),
  tradingAddress: dataCaptureSelectors.getAddressByType(state, TRADING_ADDRESS_TYPE),
  mailingAddress: dataCaptureSelectors.getAddressByType(state, MAILING_ADDRESS_TYPE),
  editButtonClicks: {
    registerEditClick: dataCaptureSelectors.getEditClickByType(state, REGISTER_ADDRESS_TYPE),
    tradingEditClick: dataCaptureSelectors.getEditClickByType(state, TRADING_ADDRESS_TYPE),
    mailingEditClick: dataCaptureSelectors.getEditClickByType(state, MAILING_ADDRESS_TYPE)
  },
  caseId: selectors.getCaseId(state),
  caseType: caseSelectors.getCaseType(state),
  linkCode: caseSelectors.getJointLinkCode(state),
  customerData: customerSelector.customerData(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BusinessTypeQuestion);
